module.exports = __webpack_public_path__ + "static/media/white.78ef76ee.svg";